/**
 * Invoices Repository (ADR-0009 Phase 2c).
 */

import { queueBusinessPayloadWrite } from '../storage/businessPayloadWrite';

function dedupeInvoices(invoices) {
  if (!Array.isArray(invoices)) return [];
  const seen = new Set();
  return invoices.filter((inv) => {
    const key = inv?.id ?? inv?.invoiceNumber ?? JSON.stringify(inv);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

export class KvInvoicesRepository {
  /**
   * @param {string} businessId
   * @param {Array} invoices
   */
  async persistSupermarketInvoices(businessId, invoices, options = {}) {
    if (!businessId || !Array.isArray(invoices)) return [];
    let merged = [];
    let prev = [];
    await queueBusinessPayloadWrite(
      businessId,
      (parsed) => {
        prev = Array.isArray(parsed.supermarketInvoices) ? parsed.supermarketInvoices : [];
        parsed.supermarketInvoices = dedupeInvoices(invoices);
        merged = parsed.supermarketInvoices;
        return parsed;
      },
      { authoritativeFields: ['supermarketInvoices'] }
    );
    if (!options.fromCloudPull) {
      try {
        const { enqueueHybridOpsSync } = await import('../../services/hybridOpsSync');
        const { enqueueHybridDeletesForRemoved } = await import('../../services/hybridDeleteSync');
        void enqueueHybridDeletesForRemoved(businessId, 'invoice', prev, merged);
        const { listChangedHybridEntities } = await import('../../services/hybridDiff');
        const changed = listChangedHybridEntities('invoice', prev, merged);
        for (const item of changed) {
          void enqueueHybridOpsSync(businessId, 'invoice', item);
        }
      } catch {
        /* optional */
      }
    }
    return merged;
  }

  /**
   * @param {string} businessId
   * @param {(parsed: object) => object|Promise<object>} mutator
   * @param {{ authoritativeFields?: string[] }} [options]
   */
  mutatePayload(businessId, mutator, options = {}) {
    return queueBusinessPayloadWrite(businessId, mutator, options);
  }
}
